var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('confirm-sensitive-content',{attrs:{"force-show":_vm.forceShow},on:{"resolve":_vm.onResolve}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }